import { render, staticRenderFns } from "./CollectivityLogoSitecore.vue?vue&type=template&id=1d7632cf"
import script from "./CollectivityLogoSitecore.vue?vue&type=script&lang=js"
export * from "./CollectivityLogoSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports